export default __webpack_public_path__ + "static/media/BLR8.06509241.jpg";